var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"reports-page-header"},[_c('h1',{staticClass:"reports-page-header__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',{staticClass:"reports-page-header__subtitle"},[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }